<template>
  <div>
    <h5>
      {{ "verify_code_sms" | setText("Подтверждение кода из смс") }}
      {{ order.client.phone }}
    </h5>
    <fg-input
      :type="`number`"
      :label="`Введите код из смс, которое пришло клиенту`"
      :labelLey="`input_sms`"
      v-model="code"
    ></fg-input>
    <br />
    <br />
    <div class="install-control">
      <button @click="next" class="btn btn-success">
        {{ "next_step" | setText("Далее") }}
      </button>
    </div>
  </div>
</template>
<script>
import { logger } from "../../../plugins/functions";

export default {
  props: {
    order: {
      default: function () {
        return {};
      },
    },
    partner: {
      default: function () {
        return {};
      },
    },
    createTransaction: {
      default: function () {},
    },
    index: {
      default: 0,
    },
    contract: {
      default: null,
    },
  },
  name: "filter",
  async created() {},
  methods: {
    cancel() {
      this.$loading(true);

      logger(this.$http, {
        name: "Отмена заказа в #PAYMART",
        description: "Начало запроса",
        model_type: "order",
        model_id: this.order.id,
      });

      this.$http
        .post(
          `${this.partner["endpoint_url"]}v1/buyers/credit/cancel`,
          {
            buyer_phone: this.order.client.phone,
            contract_id: this.contract,
          },
          {
            headers: {
              Authorization: `Bearer ${this.partner["api_secret_key"]}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data) {
            switch (response.data.result.status) {
              case 1:
                this.message = "Успешно отменен";
                this.createTransaction({
                  status: -1,
                });
                this.$emit("next", -1);
                break;
              default:
                this.message = "Заказ не отменен";
                break;
            }

            this.$notify({
              title: "PAYMART",
              message: this.message,
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
            });

            logger(this.$http, {
              name: "Отмена заказа в #PAYMART",
              description: this.message,
              model_type: "order",
              model_id: this.order.id,
            });
          }
        })
        .catch((error) => {
          logger(this.$http, {
            name: "Отмена заказа в #PAYMART",
            description: "Ошибка системы #PAYMART",
            model_type: "order",
            model_id: this.order.id,
          });

          alert("Ошибка партнера");
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    next() {
      this.save();
    },
    save() {
      this.$loading(true);
      logger(this.$http, {
        name: "Подтверждение заказа (клиент) в #PAYMART",
        description: "Начало запроса",
        model_type: "order",
        model_id: this.order.id,
      });
      this.$http
        .post(
          `${this.partner["endpoint_url"]}v1/buyers/check-user-sms`,
          {
            phone: this.order.client.phone,
            code: this.code,
            contract_id: this.contract,
          },
          {
            headers: {
              Authorization: `Bearer ${this.partner["api_secret_key"]}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data) {
            switch (response.data.result.status) {
              case 1:
                this.message = "Код смс клиента подтвержден";
                this.createTransaction({
                  client_confirmed: 1,
                });
                this.$emit("next", 4);
                break;
              case 0:
                this.message = "Неверный код из смс";
                break;
              default:
                this.message = "Неверный код из смс / неизвестная ошибка";
                break;
            }

            this.$notify({
              title: "PAYMART",
              message: this.message,
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
            });

            logger(this.$http, {
              name: "Подтверждение заказа (клиент) в #PAYMART",
              description: this.message,
              model_type: "order",
              model_id: this.order.id,
            });
          }
        })
        .catch((error) => {
          logger(this.$http, {
            name: "Подтверждение заказа (клиент) в #PAYMART",
            description: "Ошибка системы #PAYMART",
            model_type: "order",
            model_id: this.order.id,
          });
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      code: null,
      message: "",
    };
  },
};
</script>
<style lang="scss">
</style>
